export default __webpack_public_path__ + "static/media/edit_icon.a4a9b36f.svg";